export default __webpack_public_path__ + "static/bank-logo-15b9ce4e31d1718acf9ef16d90c9daef.png";